// Git information for the app
// This file is generated during build and contains git information

const gitInfo = {
  commit: import.meta.env.VITE_GIT_COMMIT || 'unknown',
  branch: import.meta.env.VITE_GIT_BRANCH || 'unknown',
  tag: import.meta.env.VITE_GIT_TAG || 'unknown',
  date: import.meta.env.VITE_GIT_DATE || 'unknown',
};

export default gitInfo;